import { composeModule } from '@opengov/compose-app';

import pkg from './package.json';

// StoriesModule only carries the `stories` locale-loader middleware, so only
// `exportModule` is needed here.
export const { exportModule } = composeModule(pkg.name, pkg.version);
